import { CdkPortalOutlet } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppBusyStateComponentDef } from '@df/ui/display/busy-state/app-busy-state.component.def';
@Component({
    selector: 'app-busy-state',
    templateUrl: './app-busy-state.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, CdkPortalOutlet]
})
export class AppBusyStateComponent extends AppBusyStateComponentDef {
}